import React from 'react'
import {withRouter} from 'react-router';
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import ChipUserAccount from "../../components/ChipUserAccount";
import CuentaSelected from "../../helpers/CuentaSelected";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import ProceedingsList from "./ProceedingsList";

class Proceedings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            proceedingsList: [],
        };
    }

    async componentDidMount() {
        await this.getProceedings();
    }

    getProceedings = async () => {
        const account = CuentaSelected.get()
        const data = await Api.get(`${Env.UrlSeguridad}/getVActaVisitaWeb/${account.cuentaCodigo}`);
        if (data.cod === '1') {
            this.setState({
                proceedingsList: data.V_ACTAVISITA_WEB,
            });
        }
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Actas'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Actas</span>
                </h2>

                <div>
                    <ProceedingsList data={this.state.proceedingsList} />
                </div>

            </div>
        );
    }
}

export default withRouter(Proceedings)